import { Component, OnInit, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/catch';
import { Animations } from '../common/animations';

// APP 
import { Entity, MIHDocument } from '../../viewmodel';
import { EntityParam } from '../../viewmodel';
import { AppFlags } from '../../viewmodel';
import { BuildingFlags } from '../../viewmodel';
import { SiteEntityParam } from '../../viewmodel';
import { BuildingQuestionParam } from '../../viewmodel';
import { MIHSiteEntityAssociations } from '../../viewmodel';
import { DevSiteAssociations } from '../../viewmodel';
import { siteBldg } from '../../viewmodel';
import { SummaryInstruction } from '../../viewmodel';

import { LookupService } from '../../services/lookup.service';
import { EntityService } from '../../services/entity.service';
import { BuildingService } from '../../services/building.service';
import { InformationService } from '../../services/information.service';
import { SharedService } from '../../services/shared.service';
import { HelperService } from '../../services/helper.service';
import { FoucsChangeService } from '../../services/focuschange.service';
import { AppConfig } from '../../app.config';
import { FilesService } from 'app/services/files.service';

@Component({
    selector: 'app-entity',
    templateUrl: './entity.component.html',
    providers: [EntityService, InformationService, BuildingService, HelperService],
    animations: [Animations.collapseInOut]
})
export class EntityComponent implements OnInit {
    animate: string = 'active';
    title: string = 'Application';
    public activeTab: string;
    public ZR23154Url: string = AppConfig.config.ZR23154Url;
    navFixed:boolean = false;
    showDelete: boolean = false;
    showContactDelete: boolean = false;
    deleteItem: any = null;

    projectDetail: Entity;
    projectId: number = 0;
    appName: string = ''; 
    entities: Array<any>;
    buildings: Array<any>;
    sites: Array<any>;
    devSiteAssociations: Array<any>;
    siteAssociations: Array<any>;
    pageError: any = [];
    pageSuccess: any = [];
    record: any;

    model: AppFlags;
    buildingFlags: BuildingFlags;
    viewModeInstructions: SummaryInstruction; 
    editModeInstructions: SummaryInstruction; 

    projDevTeamArray: any;
    showCopyEntityPopup: boolean = false;
    showNoCopyEntityPopup: boolean = false;
    showNoCopyEntityPopupMessage: string = '';
    copyToSiteProjectBuildingId: number = 0;
    siteDestination: any;
    siteEntityAssociations: MIHSiteEntityAssociations;
    showRequireInCopyDevTeamPopup: boolean = false;
    showSaveBtnInCopyDevTeamPopup: boolean = false;

    showAssociationPopup: boolean = false;  //Associations
    showRequireMsgInAssociation: boolean = false;
    showSaveBtnAssociation: boolean = false;
    showNoSiteAssociationPopup: boolean = false;
    showRemoveAssociationPopup: boolean = false;
    currentRemoveDevSiteAssociationId: number = 0;
    currentDevSiteAssociations: DevSiteAssociations;
    currentDevAssociation: any;
    devAssocationAddress:string = '';
    showDeleteEntityPopup: boolean = false;
    deleteEntityId: number = 0;
    deleteEntityCompanyName = ''; 
    showDeleteSiteEntityPopup: boolean = false;
    deleteSiteEntityId: number = 0;

    deleteBuildingId: number = 0;
    showDeleteBuildingPopup: boolean = false;

    totalFloorArea: number = 0;
    totalUnits: number = 0;
    PILValue: string = '';
    pilAlertMessage: string = '';
    displayPILMessge = false;

    haveOwner: boolean = false;
    haveApplicant: boolean = false;
    haveAttorney: boolean = false;    
    noDevTeamMember: boolean = false;
    appInfoColl: boolean = false;
    devTeamColl: boolean = false;

    //submissionFlags
    userName: string = '';
    appStatus: string = '';
    appMode: string = ''; 
    isAppEditable: boolean = false;
    lockFileUploadChanges: boolean = false;  
    disclaimerChecked: boolean = false;

    buildingQuestionsComplete: boolean = false;
    allRequireEntryComplete: boolean = false;
    showSubmitIncomplete: boolean = false;
    ShowConfirmInvalidFloorUnit: boolean = false;
    submitted: boolean = false;
    incompleteMessage: string = '';
    associationFlag: boolean = false;
    allSitesAssociated: boolean = false;
    hangingSites: Array<any>;
    haveSiteTeamMembers: boolean = false;
    documents: Array<MIHDocument>;
    fileUploadSortColumn: string = 'GroupSequence';
    fileUploadSortDirection: string = 'asc';

    constructor(private router: Router
        , private activatedRoute: ActivatedRoute
        , private filesService: FilesService
        , private entityService: EntityService
        , private informationService: InformationService
        , private buildingService: BuildingService
        , private sharedService: SharedService
        , private helperService: HelperService
        , private foucsChangeService: FoucsChangeService
        , private renderer: Renderer) {

        this.model = new AppFlags(); 
        this.buildingFlags = new BuildingFlags(); 
        this.setupInstructions();

        this.renderer.listenGlobal('window', 'scroll', (evt) => {
            this.navFixed = (evt.srcElement.body.scrollTop >= 120);
        });
    }

    ngOnInit() {
        // Set Active Tab
        var paramActiveTab = this.activatedRoute.snapshot.queryParamMap.get("activeTab");
        if (paramActiveTab) {
            this.activeTab = paramActiveTab == 'Application' ? 'Application' : 'FileUpload';
        } else {
            this.activeTab = 'Application';
        }

        this.navFixed = false;
        this.sharedService.manageSession('application');
        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {

            if (ids.projectId != null) {
                this.projectId = ids.projectId;
                this.appName = ids.appName; 
                this.appStatus = ids.appStatus;
                if (this.appStatus == 'Draft') {
                    this.isAppEditable = true;
                }
            }
        }

        if (this.projectId <= 0) {
            this.sharedService.navigateHome();
        }
        else {
            var user = this.sharedService.getJsonData("loggedInUser");
            this.userName = user.FirstName;

            this.getEntities(this.projectId);
            this.getQuestionByTypeAndGetBuildings(this.projectId);
            this.getAllDevSiteAssociationsforProj(this.projectId);
            this.getUploadDocsByProjectId(this.projectId);
        }
    }

    changeTab(tabName: string) {
        this.activeTab = tabName;
    }

    private filterByType(typeId) {
        if (this.entities != null) {
            return this.entities.filter(
                entity => entity.PartyRoleLookup ? entity.PartyRoleLookup.SeqNo === typeId : false );
        }
    }

    checkForApplicantOwnerAttorney() {
        // Check Owner
        let owners = this.filterByType(1765);
        this.haveOwner = (owners != null && owners.length > 0);

        let applicants = this.filterByType(1030);
        this.haveApplicant = (applicants != null && applicants.length > 0);

        let attorneys = this.filterByType(1880);
        this.haveAttorney = (attorneys != null && attorneys.length > 0);

        // To show the valid and invalid
        this.noDevTeamMember = (this.haveOwner == false && this.haveApplicant == false && this.haveAttorney == false);
        this.model.hasDevTeamMember = (this.haveOwner == true || this.haveApplicant == true || this.haveAttorney == true);
    }

    ///////////////////////
    getEntities(projectId) {
        this.entityService.getEntities(projectId)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {
                        this.entities = successResp.Result

                        // Check for applicant, Owner and Attorney
                        this.checkForApplicantOwnerAttorney();
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
    }

    //combine multiple methods due to dependency
    getQuestionByTypeAndGetBuildings(projectId) {
        Observable.forkJoin([
            this.informationService.getQuestionByType(projectId, 'ALL'),
            this.buildingService.getBuildingsByProjectId(projectId)
        ])
            .subscribe(
                successResp => {

                    if (!successResp[0].Success) {
                        this.showError(successResp[0].StatusMessage)
                    }
                    else {
                        //InfoSection - method1
                        this.record = successResp[0].Result;

                        // Setup Application Mode
                        if (this.record.IsInEditMode && 
                            this.appStatus != 'Pending Execution' &&
                            this.appStatus != 'Executed' &&
                            this.appStatus != 'Withdrawn') {
                            this.isAppEditable = true;
                        }

                        // Update with latest status
                        this.appStatus = this.record.CurrentStatus;
                        if (this.appStatus == 'Pending Execution' || this.appStatus == 'Executed' || this.appStatus == 'Withdrawn') {
                            this.lockFileUploadChanges = true;
                        }
                        this.updateSessionAppStatus(this.appStatus);

                        this.disclaimerChecked = this.record && this.record.Disclaimer;

                        //this.getInfoSectionFlags();
                        this.model.IsInfoSectionComplete = (this.record.MIHArea.IsValid && this.record.Const.IsValid && this.record.Ahf.IsValid);
                        if (this.record != null && this.record.Ahf != null) {
                            this.model.IsPILComplete = this.record.Ahf.IsValid;
                            if (this.record.Ahf.Hfo != null)
                                this.model.PILValue = this.PILValue = this.record.Ahf.Hfo;
                        }


                        //getBuildings method
                        if (successResp[1].Result != null && successResp[1].Result.length > 0) {
                            this.buildings = successResp[1].Result[0].buildings;
                            this.buildingFlags.showDisclaimer = successResp[1].Result[0].showDisclaimer;

                            this.buildingFlags.showMissingBuildingSection = successResp[1].Result[0].showMissingBuildingSection;
                            if (successResp[1].Result[0].showMissingBuildingSection == true) {
                                if (successResp[1].Result[0].MissingBuildingSectionHeader == 'MIH Development Building Is Missing') {
                                    this.buildingFlags.missingBuildingSectionHeader = 'MIH Development Building is Missing';
                                    this.buildingFlags.missingBuildingSectionDescription = 'A MIH Development building is a building that is a part of the MIH Development construction project which triggered the MIH requirement. You must have at least one building that is a part of your MIH Development.';
                                }
                                else if (successResp[1].Result[0].MissingBuildingSectionHeader == 'MIH Site Is Missing') {
                                    this.buildingFlags.missingBuildingSectionHeader = 'MIH Site is Missing';
                                    this.buildingFlags.missingBuildingSectionDescription = 'A MIH Site is a building containing affordable floor area that satisfies the MIH requirement for a MIH Development. You must have at least one building that contains MIH units to satisfy your MIH requirement.';
                                }
                            }

                            if (this.PILValue == 'Y')
                                this.CalculateTotalFloorAreaUnits();

                            this.getBuildingFlag(this.buildings);
                        }
                    }
                },
                error => {
                    this.showError(error.ExceptionMessage)
                });
    }

    //building data	
    getBuildingsByProjectId(projectId) {
        this.buildingService.getBuildingsByProjectId(projectId)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {

                        if (successResp.Result != null && successResp.Result.length > 0) {
                            this.buildings = successResp.Result[0].buildings;
                            this.buildingFlags.showDisclaimer = successResp.Result[0].showDisclaimer;

                            this.buildingFlags.showMissingBuildingSection = successResp.Result[0].showMissingBuildingSection;
                            if (successResp.Result[0].showMissingBuildingSection == true) {
                                if (successResp.Result[0].MissingBuildingSectionHeader == 'MIH Development Building Is Missing') {
                                    this.buildingFlags.missingBuildingSectionHeader = 'MIH Development Building is Missing';
                                    this.buildingFlags.missingBuildingSectionDescription = 'A MIH Development building is a building that is a part of the MIH Development construction project which triggered the MIH requirement. You must have at least one building that is a part of your MIH Development.';
                                }
                                else if (successResp.Result[0].MissingBuildingSectionHeader == 'MIH Site Is Missing') {
                                    this.buildingFlags.missingBuildingSectionHeader = 'MIH Site is Missing';
                                    this.buildingFlags.missingBuildingSectionDescription = 'A MIH Site is a building containing affordable floor area that satisfies the MIH requirement for a MIH Development. You must have at least one building that contains MIH units to satisfy your MIH requirement.';
                                }
                            }

                            this.CalculateTotalFloorAreaUnits();
                            this.getBuildingFlag(this.buildings);
                        }

                        if (successResp.Result != null && successResp.Result.length > 1) {
                            this.sites = successResp.Result[1];
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
    }


    addEntity(roleId, event) {

        if (roleId == 0 && this.noDevTeamMember)
            roleId = 1030;    // set Applicant

        this.sharedService.setData('entityRole', JSON.stringify({ 'entityRoleId': roleId }));
        this.router.navigate(['/createentity']);
    }

    edityEntity(entityId, entity) {

        var entityParam = new EntityParam();
        entityParam.projectId = this.projectId;
        entityParam.entityId = entity.MIHProjectDevTeamID;
        entityParam.partyId = entity.PartyID;
        entityParam.partyStagingId = entity.PartyStagingID;
        entityParam.partyAddressId = entity.PartyAddressID;
        entityParam.partyAddressStagingId = entity.PartyAddressStagingID;
        entityParam.newEntityEntry = 'N';
        this.sharedService.setJsonData('entityParam', entityParam);
        this.router.navigate(['/editentity']);
    }



    addBuilding(buildingId, event) {

        if (buildingId != null) {
            this.sharedService.setJsonData('building', {'buildingId': buildingId, 'type': 'DEV' });
        }
        this.router.navigate(['/addbuilding']);
    }

    CalculateTotalFloorAreaUnits() {
        let tUnits = 0;
        this.totalUnits = 0;
        let tFloorArea = 0;
        this.totalFloorArea = 0;
        if (this.buildings != null && this.buildings.length > 0) {

            for (var i = 0; i < this.buildings.length; i++) {
                if (this.buildings[i].ProjectBuildingUnitCount != null || this.buildings[i].ProjectBuildingUnitCount != '')
                    tUnits += this.buildings[i].ProjectBuildingUnitCount;

                if (this.buildings[i].ProjectBuildingFloorArea != null || this.buildings[i].ProjectBuildingFloorArea != '')
                    tFloorArea += this.buildings[i].ProjectBuildingFloorArea;
            }

            this.totalUnits = tUnits;
            this.totalFloorArea = tFloorArea;
            this.generatePaymentInLiuAlertMessage();
        }
    }

    generatePaymentInLiuAlertMessage() {
        var units = this.totalUnits;
        var areas = this.totalFloorArea;
        var U1 = 11;      // units range 1 
        var U2 = 25;      // units range 2
        var F1 = 12500;   // floor area  range 1
        var F2 = 25000;   // floor area range 2
        var message = '';
        var messageid = '';   //for test purpose
        var ZR23HtmlString = ' <a href="'+ this.ZR23154Url +'" class="hrefLook"  target= "_blank">See ZR 23-154(d)(3)(v)</a>';

        if (units < U1) {
            if (areas < F1) {
                messageid = 'A1';
                message = '';
                this.displayPILMessge = false;
            }
            else if (areas < F2) {
                messageid = 'A2';
                message = '';
                this.displayPILMessge = false;
            }
            else if (areas >= F2) {
                messageid = 'A3';
                message = 'The total residential floor area for your MIH Development building(s) is equal to or over 25,000 square feet; you may be required to provide affordable housing.' + ZR23HtmlString;
                this.displayPILMessge = true;
            }
        }
        else if (units <= U2) {
            if (areas < F1) {
                messageid = 'B1';
                message = '';
                this.displayPILMessge = false;
            }
            else if (areas < F2) {
                messageid = 'B2';
                message = '';
                this.displayPILMessge = false;
            }
            else if (areas >= F2) {
                messageid = 'B3';
                message = 'The total residential floor area for your MIH Development building(s) is equal to or over 25,000 square feet; you may be required to provide affordable housing. ' + ZR23HtmlString;
                this.displayPILMessge = true;
            }
        }
        else if (units > U2) {
            if (areas < F1) {
                messageid = 'C1';
                message = '';
                this.displayPILMessge = false;
            }
            else if (areas < F2) {
                messageid = 'C2';
                message = 'The total unit count for your MIH Development building(s) is over 25 units; you may be required to provide affordable housing. ' + ZR23HtmlString;
                this.displayPILMessge = true;
            }
            else if (areas >= F2) {
                messageid = 'C3';
                message = 'The total unit count for your MIH Development building(s) is over 25 units and the total residential floor area for your MIH Development building(s) is equal to or over 25,000 square feet; you may be required to provide affordable housing. ' + ZR23HtmlString;
                this.displayPILMessge = true;
            }
        }

        this.pilAlertMessage = message;
    }

    cancelDelete(event) {
        this.showDelete = false;
        event.stopPropagation();
    }

    cancelContactDelete(event) {
        this.showContactDelete = false;
        event.stopPropagation();
    }

    confirmContactDelete(event) {
        this.showContactDelete = false;
        event.stopPropagation();
    }

    delete(item) {
        event.stopPropagation();
    }

    deleteDevBuilding() {
        event.stopPropagation();
    }

    confirmDelete() {
        this.showDelete = false;
    }

    closeError() {
        this.pageError = [];
        this.pageSuccess = [];
    }

    showError(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(this.sharedService.getCustomError(msg));
        this.sharedService.processError(msg);
    }

    showErrorAlert(msg) {
        this.pageError = []; this.pageSuccess = [];
        this.pageError.push(msg);
        this.sharedService.processError(msg);
    }

    showSuccess(msg) {
        this.pageSuccess = []; this.pageError = [];
        this.pageSuccess.push(msg);
        this.sharedService.scroll();

        setTimeout(() => {
            this.pageSuccess = []; 
            this.pageError = [];
        }, 3000); 
    }

    addBldgQuestion(building, questionType) {
        var path = '';
        var devProjBldgId = building.DevProjectBuildingID == null ? building.SiteProjectBuildingID : building.DevProjectBuildingID;
        if (devProjBldgId == null || devProjBldgId==0)
            return false;

        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingID;
        BQP.siteProjectBuildingId = building.SiteProjectBuildingID;
        BQP.bldgId = building.BldgID;
        BQP.buildingAddress = this.getAddress(building);
        BQP.mood = 'A';

        switch (questionType) {
            case 702:
                path = "/buildings/unitcount";
                break;
            case 703:
                path = "/buildings/publicfunding";
                break;
            case 704:
                path = "/buildings/mihoptions";
                break;
            case 705:
                path = "/buildings/mihunits";
                break;
            case 790:
                path = "/buildings/buildingtype";
                break;
            default:
                break;
        }

        if (path != '') {
            this.sharedService.setJsonData('BuildingQuestionParam', BQP);
            this.router.navigate([path]);
        }
    }

    editBldgQuestion(building, questionType) {

        var path = '';
        var devProjBldgId = building.DevProjectBuildingID == null ? building.SiteProjectBuildingID : building.DevProjectBuildingID;
        if (devProjBldgId == null || devProjBldgId == 0)
            return false;

        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingID;
        BQP.siteProjectBuildingId = building.SiteProjectBuildingID;
        BQP.bldgId = building.BldgID;
        BQP.buildingAddress = this.getAddress(building);
        BQP.mood = 'E';

        if (building.ProjectBuildingType != null && building.ProjectBuildingType.SeqNo == 2060)
            BQP.buildingTypeId = building.ProjectBuildingType.SeqNo;

        switch (questionType) {
            case 702:
                path = "/buildings/unitcount";
                break;
            case 703:
                path = "/buildings/publicfunding";
                break;
            case 704:
                path = "/buildings/mihoptions";
                break;
            case 705:
                path = "/buildings/mihunits";
                break;
            case 790:
                path = "/buildings/buildingtype";  // to check
                break;
            default:
                break;
        }
        if (path != '') {
            this.sharedService.setJsonData('BuildingQuestionParam', BQP);
            this.router.navigate([path]);
        }
    }

    addSiteQuestion(building, questionType) {

        var path = '';
        var siteProjBldgId = building.SiteProjectBuildingID;
        if (siteProjBldgId == null || siteProjBldgId == 0)
            return false;

        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingID; // building.DevProjectBuildingID;
        BQP.siteProjectBuildingId = building.SiteProjectBuildingID;
        BQP.bldgId = building.BldgID;
        BQP.buildingAddress = this.getAddress(building);
        BQP.mood = 'A';

        switch (questionType) {
            case 702:
                path = "/buildings/unitcount";
                break;
            case 703:
                path = "/buildings/publicfundingsite";
                break;
            case 704:
                path = "/buildings/mihoptions";
                break;
            case 705:
                path = "/buildings/locationmihsiteunit";
                break;
            case 706:
                path = "/buildings/taxcredit";
                break;
            case 707:
                path = "/buildings/taxincentive";
                break;
            case 708:
                path = "/buildings/siteunitcount";
                break;
            case 7081:
                path = "/buildings/condostructure";
                break;
            case 7082:
                path = "/buildings/electricsystems";
                break;
            default:
                break;
        }

        if (path != '') {
            this.sharedService.setJsonData('BuildingQuestionParam', BQP);
            this.router.navigate([path]);
        }
    }

    editSiteQuestion(building, site, questionType) {
        var path = '';
        var address = '';
        if (site.SiteProjectBuildingId == null || site.SiteProjectBuildingId == 0 || site.BuildingId == null || site.BuildingId == 0)
            return false;

        var BQP = new BuildingQuestionParam();
        BQP.devProjectBuildingId = building.DevProjectBuildingID;    //site.DevProjectBuildingId; 
        BQP.siteProjectBuildingId = site.SiteProjectBuildingId;
        BQP.bldgId = site.BuildingId;
        BQP.buildingAddress = this.getAddress(building);
        BQP.mood = 'E';

        switch (questionType) {
            case 703:
                path = "/buildings/publicfundingsite";
                break;
            case 705:
                path = "/buildings/locationmihsiteunit";
                break;
            case 706:
                path = "/buildings/taxcredit";
                break;
            case 707:
                path = "/buildings/taxincentive";
                break;
            case 708:
                path = "/buildings/siteunitcount";
                break;
            case 7081:
                path = "/buildings/condostructure";
                break;
            case 7082:
                path = "/buildings/electricsystems";
                break;
            default:
                break;
        }
        if (path != '') {
            this.sharedService.setJsonData('BuildingQuestionParam', BQP);
            this.router.navigate([path]);
        }
    }

    getAddress(building) {
        var addr = '';
        if (building == null)
            return '';

        if (!(building.HouseNumber == null || building.HouseNumber == ''))
            addr = building.HouseNumber + ' ';
        if (building.StreetName != null)
            addr += building.StreetName;

        return addr;
    }

    addSiteEntity(site, roleId) {

        if (roleId == 0 && this.noDevTeamMember)
            roleId = 1030;    // set Applicant

        var buildingAddress = '';
        if (site.SiteProjectBuildingID == null || site.SiteProjectBuildingID == 0)
            return false;

        var sep = new SiteEntityParam();
        sep.projectBldgDevTeamId = 0;
        //sep.devProjectBuildingId = site.devProjectBuildingID; 
        sep.siteProjectBuildingId = site.SiteProjectBuildingID;
        sep.bldgId = site.BldgID;
        sep.entityRole = roleId;  // applicant
        sep.siteAddress = this.helperService.getSiteAddress(site);
        this.sharedService.setData('SiteEntityParam', JSON.stringify({ sep }));
        this.router.navigate(['entity/addsiteentity']);
    }

    editSiteEntity(entityId, entity, building) {

        var sep = new SiteEntityParam();
        sep.projectId = this.projectId;

        sep.projectBldgDevTeamId = entity.MIHProjectBldgDevTeamID;
        sep.siteProjectBuildingId = building.SiteProjectBuildingID;
        sep.bldgId = entity.BldgID;
        sep.entityRole = entity.PartyRoleLookup.SeqNo;  //roleId;  // applicant

        sep.siteAddress = this.helperService.getSiteAddress(building);
        sep.partyId = entity.PartyID;
        sep.partyStagingId = entity.PartyStagingID;
        sep.partyAddressId = entity.PartyAddressID;
        sep.partyAddressStagingId = entity.PartyAddressStagingID;
        sep.mood = 'E';

        this.sharedService.setJsonData('SiteEntityParam', sep);
        this.router.navigate(['entity/editsiteentity']);
    }

    ////////// copy project DevTeam members to site //////////

    showCopyEntity(site) {

        if (this.noDevTeamMember) {
            this.showNoCopyEntityPopupMessage = "There are no development team members added to this application.";
            this.showNoCopyEntityPopup = true;
            this.foucsChangeService.changeFocus(false);
            return false;
        }

        this.entityService.getDevTeamEntitiesForSite(this.projectId, site.SiteProjectBuildingID)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {
                        this.projDevTeamArray = successResp.Result;

                        if (this.projDevTeamArray !=null && this.projDevTeamArray.length > 0) {
                            this.siteDestination = site;
                            this.showCopyEntityPopup = true;
                            this.foucsChangeService.changeFocus(false);
                        }
                        else {
                            // No Dev team to copy 
                            this.showNoCopyEntityPopupMessage = "All Development team members have already been added to this Site's team.";
                            this.showNoCopyEntityPopup = true;
                            this.foucsChangeService.changeFocus(false);
                        }
                    }
                },
                error => {
                    this.showError(error.ExceptionMessage);
                });
    }

    CopyDevTeamToSite(event) {
        var devTeamSelected: any = [];

        if (this.projDevTeamArray != null) {

            var array = this.projDevTeamArray;
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                if (item.isChecked == true) {
                    if (item.MIHProjectDevTeamID > 0)
                        devTeamSelected.push(item.MIHProjectDevTeamID);
                }
            }

            if (devTeamSelected != null) {
                var association = new MIHSiteEntityAssociations();
                association.projectId = this.projectId;
                association.siteProjBuildingId = this.siteDestination.SiteProjectBuildingID;  //this.copyToSiteProjectBuildingId; 
                association.bldgId = this.siteDestination.BldgID;
                association.ProjDevTeamIds = devTeamSelected;

                this.associateDevTeamEntitiestoSite(association);   // save associate dev team to site                 
            }
        }
    }

    // save associate dev teams to site 
    associateDevTeamEntitiestoSite(association) {
        this.showCopyEntityPopup = false;
        this.foucsChangeService.changeFocus(true);
        this.entityService.AssociateDevTeamEntitiestoSite(association)
            .subscribe(
                success => {
                    if (!success.Success) {
                        this.showError(success.StatusMessage);
                        this.siteDestination = null;
                    }
                    else {
                        //TODO 
                        this.siteDestination = null;
                        this.getBuildingsByProjectId(this.projectId);  // display/synced changes in summary view                  
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.siteDestination = null;
                    this.showError(error.ExceptionMessage);
                })
    }

    cancelCopy(event) {
        this.showCopyEntityPopup = false;
        this.foucsChangeService.changeFocus(true);
        this.showRequireInCopyDevTeamPopup = false;
        this.showSaveBtnInCopyDevTeamPopup = false;
        this.siteDestination = null;
        event.stopPropagation();
    }

    cancelNoCopyEntity(event) {
        this.showNoCopyEntityPopup = false;
        this.showNoCopyEntityPopupMessage = '';
        this.showRequireInCopyDevTeamPopup = false;
        this.showSaveBtnInCopyDevTeamPopup = false;
        this.siteDestination = null;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }

    changeTeamCheckbox(index) {

        var isChecked = false;
        if (this.projDevTeamArray != null) {
            var array = this.projDevTeamArray;
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                if (item.isChecked == true) {
                    isChecked = true;
                    break;
                }
            }
        }
        this.showRequireInCopyDevTeamPopup = !isChecked;
        this.showSaveBtnInCopyDevTeamPopup = isChecked;
    }
    //////////end copy project DevTeam members to site //////////

    ////////// building Associations section //////////
    getAllDevSiteAssociationsforProj(projectId) {

        this.buildingService.GetAllDevSiteAssociationsforProj(projectId)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {
                        if (successResp.Result != null) {
                            if (successResp.Result.devSiteAssociationDetails != null && successResp.Result.devSiteAssociationDetails.length > 0) {
                                this.devSiteAssociations = successResp.Result.devSiteAssociationDetails;
                                this.allSitesAssociated = successResp.Result.isAllSiteAssociated;

                                if (this.allSitesAssociated != true && successResp.Result.sitesNeedToAssociate != null) {
                                    this.hangingSites = successResp.Result.sitesNeedToAssociate;
                                }
                            }
                            //update current associationFlag
                            this.devSiteAssociations = successResp.Result.devSiteAssociationDetails; 
                            this.associationFlag = this.IsAssociationComplete(this.devSiteAssociations);
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
    }

    //Association LightBox 
    showAssociationLightbox(devBldg) {

        this.devAssocationAddress = devBldg.HouseNumber + ' ' + devBldg.StreetName;
        this.buildingService.GetSitesToAddToDevProjectBuilding(this.projectId, devBldg.MIHProjectBuildingID)
            .subscribe(
                successResp => {

                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage)
                    }
                    else {
                        this.siteAssociations = successResp.Result;
                        if (this.siteAssociations != null && this.siteAssociations.length>0) {
                            this.showAssociationPopup = true;
                            this.foucsChangeService.changeFocus(false);
                            this.currentDevSiteAssociations = new DevSiteAssociations();
                            this.currentDevSiteAssociations.devProjBuildingId = devBldg.MIHProjectBuildingID;
                            this.currentDevSiteAssociations.devBldgId = devBldg.BldgID;
                            this.currentDevSiteAssociations.projectId = this.projectId;

                        }
                        else {
                            this.showAssociationPopup = false;
                            this.showNoSiteAssociationPopup = true;
                            this.foucsChangeService.changeFocus(false);
                        }
                    }
                },
                error => {
                    this.showError(error.ExceptionMessage);
                });

    }

    AddAssociation(event) {
        var siteAssociationSelected: any = [];
        if (this.siteAssociations != null) {

            var array = this.siteAssociations;
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                if (item.isChecked == true) {
                    if (item.MIHProjectBuildingID > 0) {

                        var sBldg = new siteBldg();
                        sBldg.siteProjBuildingId = item.MIHProjectBuildingID;
                        sBldg.siteBldgId = item.BldgID;
                        siteAssociationSelected.push(sBldg);
                    }
                }
            }

            if (siteAssociationSelected != null && siteAssociationSelected.length > 0) {
                this.currentDevSiteAssociations.siteBldgs = siteAssociationSelected;
                this.AssocaiateDevAndSite(this.currentDevSiteAssociations);   // save associate dev and site

                this.showAssociationPopup = false;
                this.showRequireInCopyDevTeamPopup = false;
                this.showSaveBtnAssociation = false;
                this.siteAssociations = null;
                this.foucsChangeService.changeFocus(true);
            }
            else {

            }
        }
    }

    // save AssocaiateDevAndSite
    AssocaiateDevAndSite(devSiteAssociations) {
        this.showCopyEntityPopup = false;
        this.foucsChangeService.changeFocus(true);
        this.buildingService.AssocaiateDevAndSite(devSiteAssociations)
            .subscribe(
                success => {
                    if (!success.Success) {
                        this.showError(success.StatusMessage);
                        this.currentDevSiteAssociations = null;
                    }
                    else {
                        //save success. partial refresh in summary view
                        this.currentDevSiteAssociations = null;
                        this.getQuestionByTypeAndGetBuildings(this.projectId);
                        this.getAllDevSiteAssociationsforProj(this.projectId);
                        //window.location.reload();
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.currentDevSiteAssociations = null;
                    this.showError(error.ExceptionMessage);
                })
    }

    removeAssociationPopup(devSiteAssociationId) {
        this.showRemoveAssociationPopup = true;
        this.currentRemoveDevSiteAssociationId = devSiteAssociationId;
        this.foucsChangeService.changeFocus(false);
    }

    removeDevSiteAssociation(devSiteAssociationId) {

        if (devSiteAssociationId > 0) {
            this.showRemoveAssociationPopup = false;
            this.foucsChangeService.changeFocus(true);
            this.buildingService.DeleteDevSiteAssociation(devSiteAssociationId)
                .subscribe(
                    success => {
                        if (!success.Success) {
                            this.showError(success.StatusMessage);
                            this.currentRemoveDevSiteAssociationId = 0;
                        }
                        else {
                            //save success. partial refresh in summary view                        
                            this.currentRemoveDevSiteAssociationId = 0;
                            this.getQuestionByTypeAndGetBuildings(this.projectId);
                            this.getAllDevSiteAssociationsforProj(this.projectId);
                            //window.location.reload();
                        }
                    },
                    error => {
                        if (error.status == 401)
                            this.router.navigateByUrl('/login?session=0');

                        this.currentRemoveDevSiteAssociationId = 0;
                        this.showError(error.ExceptionMessage);
                    })
        }
    }

    cancelRemoveAssociation() {
        this.showRemoveAssociationPopup = false;
        this.currentRemoveDevSiteAssociationId = 0;
        this.foucsChangeService.changeFocus(true);
    }

    cancelAssociation(event) {
        this.showAssociationPopup = false;
        this.showRequireMsgInAssociation = false;
        this.showSaveBtnAssociation = false;
        this.foucsChangeService.changeFocus(true);
        this.siteAssociations = null;
        this.currentDevSiteAssociations = null;
        event.stopPropagation();
    }

    cancelNoSiteAssociation(event) {
        this.showNoSiteAssociationPopup = false;
        this.currentDevSiteAssociations = null;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }


    changeAssociationCheckbox(index) {
        var isChecked = false;
        if (this.siteAssociations != null) {
            var array = this.siteAssociations;
            for (var i = 0; i < array.length; i++) {
                var item = array[i];
                if (item.isChecked == true) {
                    isChecked = true;
                    break;
                }
            }
        }
        this.showSaveBtnAssociation = isChecked;
        this.showRequireMsgInAssociation = !isChecked;
    }

    IsAssociationComplete(devSiteAssociations) {
        var flag = true;
        if (devSiteAssociations == null || devSiteAssociations.length == 0)
            return false;

        for (var i = 0; i < devSiteAssociations.length; i++) {
            if (devSiteAssociations[i].devSiteAssociations == null || devSiteAssociations[i].devSiteAssociations.length == 0) {
                flag = false;
                break;
            }
        }

        return flag;
    }

    ////////// end building associations section  //////////

    //////////////// submit application to HPD ////////////////
    getBuildingCheckList() {
        this.buildingService.getBuildingsByProjectId(this.projectId)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {
                        if (successResp.Result != null && successResp.Result.length > 0) {
                            this.buildings = successResp.Result[0].buildings;
                            this.CalculateTotalFloorAreaUnits();

                            this.getBuildingFlag(this.buildings);

                        }

                        if (successResp.Result != null && successResp.Result.length > 1) {
                            this.sites = successResp.Result[1];
                        }
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
    }

    getBuildingFlag(bldgs) {      
        var bqFlag = true;
        if (bldgs == null) {
            this.buildingQuestionsComplete = bqFlag = false;
            return false;
        }

        //PIL Yes case  
        if (this.PILValue == 'Y') {
            for (var i = 0; i < bldgs.length; i++) {
                if (bldgs[i].ProjectBuildingFloorArea == 0 || bldgs[i].ProjectBuildingFloorArea == null
                    || bldgs[i].ProjectBuildingUnitCount == 0 || bldgs[i].ProjectBuildingUnitCount == null) {
                    this.buildingQuestionsComplete = false;
                    bqFlag = false;
                    break;
                }
            }

            this.buildingQuestionsComplete = bqFlag;
            var flags = (this.PILValue == 'Y' && this.model.IsInfoSectionComplete && this.buildingQuestionsComplete
                && (this.haveOwner == true && this.haveApplicant == true && this.haveAttorney == true));

        }
        else if (this.PILValue == 'N') {
            //Non PIL case 
            for (var i = 0; i < bldgs.length; i++) {
                if (bldgs[i].ProjectBuildingFloorArea == 0 || bldgs[i].ProjectBuildingFloorArea == null
                    || bldgs[i].ProjectBuildingUnitCount == 0 || bldgs[i].ProjectBuildingUnitCount == null) {
                    bqFlag = false;        //BQ1 
                    break;
                }
                bqFlag = this.IsBuildingQuestionComplete(bldgs[i]);
                this.buildingQuestionsComplete = bqFlag;
                if (bqFlag == false) {
                    break;  // out of loop
                }
            }

            this.buildingQuestionsComplete = bqFlag;
            //check siteTeam member only if buildingQuestion is complete - submission purpose          
            if (bqFlag) {
                this.haveSiteTeamMembers = this.HaveSiteTeamMembers(bldgs);
            }
        }
    }

    IsBuildingQuestionComplete(bldg) {
        var isComplete = true;
        var bldgType = 0;
        if (bldg == null || bldg.ProjectBuildingType == null)
            return false;

        if (bldg.ProjectBuildingType.SeqNo == null || bldg.ProjectBuildingType.SeqNo == 0) {
            return false;
        }
        else {
            bldgType = bldg.ProjectBuildingType.SeqNo;
            switch(bldgType) {
                case 2059:
                    if (bldg.ProjectBuildingPublicFunding == null || bldg.ProjectBuildingPublicFunding.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingMIHOption == null || bldg.ProjectBuildingMIHOption.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingMIHOption == null || bldg.ProjectBuildingMIHOption.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingLocationOfMIHUnits == null || bldg.ProjectBuildingLocationOfMIHUnits.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    break;

                case 2061:
                    if (bldg.ProjectBuildingPublicFunding == null || bldg.ProjectBuildingPublicFunding.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingMIHOption == null || bldg.ProjectBuildingMIHOption.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingMIHOption == null || bldg.ProjectBuildingMIHOption.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingLocationOfMIHUnits == null || bldg.ProjectBuildingLocationOfMIHUnits.IsValid == false) {
                        isComplete = false;
                        break;
                    }

                    if (bldg.ProjectBuildingTaxCredits == null || bldg.ProjectBuildingTaxCredits.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingTaxIncentives == null || bldg.ProjectBuildingTaxIncentives.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingResidentialMIHSuperUnits == null || bldg.ProjectBuildingResidentialMIHSuperUnits.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingCondoStructure == null || bldg.ProjectBuildingCondoStructure.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingElectricSystems == null || bldg.ProjectBuildingElectricSystems.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    break;
                case 2060:
                    if (bldg.ProjectBuildingPublicFunding == null || bldg.ProjectBuildingPublicFunding.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingSiteLocation == null || bldg.ProjectBuildingSiteLocation.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingTaxCredits == null || bldg.ProjectBuildingTaxCredits.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingTaxIncentives == null || bldg.ProjectBuildingTaxIncentives.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingResidentialMIHSuperUnits == null || bldg.ProjectBuildingResidentialMIHSuperUnits.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingCondoStructure == null || bldg.ProjectBuildingCondoStructure.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    if (bldg.ProjectBuildingElectricSystems == null || bldg.ProjectBuildingElectricSystems.IsValid == false) {
                        isComplete = false;
                        break;
                    }
                    break;
                default:
                    isComplete = false;
                    break;
            }
        }

        return isComplete;
    }

    HaveSiteTeamMembers(bldgs) {
        var flag = true;
        if (bldgs == null || bldgs.length == 0)
            return false;

        for (var i = 0; i < bldgs.length; i++) {

            if (bldgs[i].ProjectBuildingType != null
                && (bldgs[i].ProjectBuildingType.SeqNo == 2060 || bldgs[i].ProjectBuildingType.SeqNo == 2061 || (bldgs[i].IsDevBuilding && bldgs[i].ProjectBuildingLocationOfMIHUnits.IsDevSite)) ) {
                var hasSiteApplicant = false;
                var hasSiteOwner = false;
                var hasSiteArchitect = false;

                if (bldgs[i].BuildingDevTeam == null || bldgs[i].BuildingDevTeam.length < 3) {
                    return false;
                }

                for (var j = 0; j < bldgs[i].BuildingDevTeam.length; j++) {
                    var team = bldgs[i].BuildingDevTeam[j];
                    var roleId = 0;
                    if (team.PartyRoleLookup != null)
                        roleId = team.PartyRoleLookup.SeqNo;

                    switch (roleId) {
                        case 1030:
                            hasSiteApplicant = true;
                            break;
                        case 1032:
                            hasSiteOwner = true;
                            break;
                        case 1765:
                            hasSiteArchitect = true;
                            break;
                        default:
                            break;
                    }

                }

                if (!(hasSiteApplicant && hasSiteOwner && hasSiteArchitect)) {
                    return false;
                }
            }   // end each site, dev-site

        }

        return flag;
    }

    validateCheckList(event) {
        var checkListMessage = '';
        this.incompleteMessage = '';
        // MIH-1324 check for validations
        checkListMessage = '';
        if (!((this.buildingQuestionsComplete && this.model.IsInfoSectionComplete && (this.haveOwner == true && this.haveApplicant == true && this.haveAttorney == true))
            && (this.PILValue == 'Y' || (this.PILValue == 'N' && this.haveSiteTeamMembers && this.associationFlag))))
        {   
            this.submitted = false;
            checkListMessage = '<li>Incomplete sections are highlighted in red. Please navigate to the appropriate sections and complete the required information before submitting the application.</li>';
        }
      
        if (((this.buildingQuestionsComplete && this.model.IsInfoSectionComplete && (this.haveOwner == true && this.haveApplicant == true && this.haveAttorney == true))
            && (this.PILValue == 'Y' || (this.PILValue == 'N' && this.haveSiteTeamMembers && this.associationFlag))))
           {
            this.submitted = true;
            if (this.disclaimerChecked != true) {
                checkListMessage += '<li>Please read and accept the disclaimer.</li>';
            }

            // display incomplete hanging site message - check if all sites are associated.
            if (this.PILValue == 'N' && (!this.allSitesAssociated)) {               
                var hangingSiteAddress = this.getHangingSiteAddressHtml(); 
                if (hangingSiteAddress != '') {
                   checkListMessage += '<li>The following building(s) have not yet been associated to a MIH development building:' + hangingSiteAddress + '</li>';
                }
            }  
        }

        if (checkListMessage.trim() != '') {
            this.incompleteMessage = '<ol>' + checkListMessage + '<ol>';
            this.showSubmitIncomplete = true;
            this.foucsChangeService.changeFocus(false);
            return false;
        }
        else {

            if (this.PILValue == 'Y') {
                if (this.model.IsInfoSectionComplete && (this.haveOwner && this.haveApplicant && this.haveAttorney)
                    && this.buildingQuestionsComplete) {
                    if (this.displayPILMessge == true && this.pilAlertMessage.trim() != '') {
                        this.ShowConfirmInvalidFloorUnit = true;
                        this.foucsChangeService.changeFocus(false);
                    }
                    else {
                        this.submitApplication();
                    }
                }
            }  //end PIL Yes
            else if (this.PILValue == 'N') {

                if (this.model.IsInfoSectionComplete
                    && (this.haveOwner && this.haveApplicant && this.haveAttorney)
                    && this.buildingQuestionsComplete && this.haveSiteTeamMembers
                    && this.associationFlag) {

                    if (this.allSitesAssociated) {
                        this.submitApplication();
                    }
                }
            }
        }
    }

    confirmSubmit(event) {
        this.ShowConfirmInvalidFloorUnit = false;   //close diglog
        this.foucsChangeService.changeFocus(true);
        this.submitApplication();
    }

    submitApplication() {
        this.getBuildingCheckList();

        this.entityService.submitApplication(this.projectId)
            .subscribe(
                success => {
                    if (!success.Success) {

                        if (success.StatusMessage != null && success.StatusMessage.indexOf('because it has been withdrawn') !== -1) {
                            this.showErrorAlert(success.StatusMessage);
                        }
                        else {
                            this.showError(success.StatusMessage);
                        }
                    }
                    else {
                        if (this.appStatus == 'Draft') {
                            this.appStatus = 'Submitted';
                            this.appMode = 'Complete'
                            this.showSuccess('Your application has been successfully submitted. You may now proceed to upload your supporting documentation.');
                        }
                        else {
                            this.appMode = 'Complete'; 
                        }

                        this.updateSessionEditMode(this.appMode); 
                        this.updateSessionAppStatus(this.appStatus);
                        this.isAppEditable = false;
                        this.activeTab = 'FileUpload';
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage);
                });
    }

    cancelSubmit(event) {
        this.showSubmitIncomplete = false;
        this.foucsChangeService.changeFocus(true);
        this.incompleteMessage = '';
        this.activeTab = 'Application';
        event.stopPropagation();
    }

    cancelConfirmFloorUnit(event) {
        this.ShowConfirmInvalidFloorUnit = false;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }

    ////////// end of submission ///////////
    ////////// Delete ///////////
    deleteEntity(entity) {
        this.showDeleteEntityPopup = true;
        this.deleteEntityId = entity.MIHProjectDevTeamID; 
        this.deleteEntityCompanyName = entity.PartyName;  
        this.foucsChangeService.changeFocus(false);
    }

    deleteDevTeamEntity(deleteEntityId, deleteCompanyName) {
        if (deleteEntityId > 0) {
            this.showDeleteEntityPopup = false;
            this.foucsChangeService.changeFocus(true);
            this.entityService.deleteDevTeamEntity(deleteEntityId, deleteCompanyName, this.projectId)
                .subscribe(
                    success => {
                        if (!success.Success) {
                            this.showError(success.StatusMessage);
                            this.deleteEntityId = 0;
                        }
                        else {
                            //save success. partial refresh in summary view
                            this.deleteEntityId = 0;
                            this.deleteEntityCompanyName = '';
                            this.getEntities(this.projectId);
                        }
                    },
                    error => {
                        if (error.status == 401)
                            this.router.navigateByUrl('/login?session=0');

                        this.deleteEntityId = 0;
                        this.showError(error.ExceptionMessage);
                    })
        }
    }

    cancelDeleteEntity() {
        this.showDeleteEntityPopup = false;
        this.foucsChangeService.changeFocus(true);
        this.deleteEntityId = 0;
        this.deleteEntityCompanyName = '';
    }
    /////// DeleteSiteEntity /////
    clickDeleteSiteEntity(deleteSiteEntityId) {
        this.showDeleteSiteEntityPopup = true;
        this.deleteSiteEntityId = deleteSiteEntityId;
        this.foucsChangeService.changeFocus(false);
    }

    deleteSiteEntity(deleteSiteEntityId) {
        if (deleteSiteEntityId > 0) {
            this.entityService.deleteSiteTeamEntity(deleteSiteEntityId)
                .subscribe(
                    success => {
                        if (!success.Success) {
                            this.showError(success.StatusMessage);
                            this.deleteSiteEntityId = 0;
                        }
                        else {
                            this.showDeleteSiteEntityPopup = false;
                            this.foucsChangeService.changeFocus(true);
                            this.deleteSiteEntityId = 0;
                            this.getQuestionByTypeAndGetBuildings(this.projectId);

                        }
                    },
                    error => {
                        if (error.status == 401)
                            this.router.navigateByUrl('/login?session=0');

                        this.deleteSiteEntityId = 0;
                        this.showError(error.ExceptionMessage);
                    })
        }
    }

    cancelDeleteSiteEntity(deleteSiteEntityId) {
        this.showDeleteSiteEntityPopup = false;
        this.deleteSiteEntityId = 0;
        this.foucsChangeService.changeFocus(true);
    }


    clickDeleteBuilding(building) {
        this.showDeleteBuildingPopup = true;
        this.deleteBuildingId = building.BldgID; // deleteBuildingId;
        this.foucsChangeService.changeFocus(false);
    }

    deleteBuilding(deleteBuildingId) {
        this.showDeleteBuildingPopup = false;
        this.foucsChangeService.changeFocus(true);
        if (deleteBuildingId > 0) {
            this.buildingService.deleteBuilding(this.projectId, deleteBuildingId)
                .subscribe(
                    success => {
                        if (!success.Success) {
                            this.showError(success.StatusMessage);
                            this.deleteBuildingId = 0;
                        }
                        else {
                            this.deleteBuildingId = 0;
                            this.getQuestionByTypeAndGetBuildings(this.projectId);
                            this.getAllDevSiteAssociationsforProj(this.projectId);
                        }
                    },
                    error => {
                        if (error.status == 401)
                            this.router.navigateByUrl('/login?session=0');

                        this.deleteSiteEntityId = 0;
                        this.showError(error.ExceptionMessage);
                    })
        }
    }

    cancelDeleteBuilding(event) {
        this.showDeleteBuildingPopup = false;
        this.deleteBuildingId = 0;
        this.foucsChangeService.changeFocus(true);
        event.stopPropagation();
    }

    getHangingSiteAddressHtml() {
        var htmlHangingSiteAddress = ''; 
        for (var i = 0; i < this.hangingSites.length; i++) { 
            if (this.hangingSites[i].HouseNumber != '') {
                htmlHangingSiteAddress += '<p>' + this.hangingSites[i].HouseNumber + ' ' + this.hangingSites[i].StreetName + '</p>'; 
            }
        }

        return htmlHangingSiteAddress; 
    }

    GotoTop(event) {
        var element = document.getElementById("top");
        if (element) {
            window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': element.offsetTop
            });
        }
        else
        {
            window.scrollTo(0, 0);
        }
    }

    goToHome() {
        this.sharedService.navigateHome();
    }

    setupInstructions() {
        this.viewModeInstructions = new SummaryInstruction(); 
        this.viewModeInstructions.appSummaryText = 'Below is the summary of your submitted MIH application. The Inclusionary Housing project manager assigned to your application will be in contact with you shortly. If your application is in need of an update, please be sure to inform your project manager.'; 
        this.viewModeInstructions.devTeamText = 'A development entity is any entity that is a part of the MIH Development construction project. Your MIH Development Team is listed below. '; 
        this.viewModeInstructions.siteTeamText = 'A site entity is any entity that is a part of the MIH Site construction project. Your MIH Site Team for this building is listed below.'; 
        this.viewModeInstructions.associationText = 'This section identifies the MIH Site(s) that will contain the MIH units to satisfy the MIH requirement for your MIH Development.';         

        this.editModeInstructions = new SummaryInstruction(); 
        this.editModeInstructions.appSummaryText = 'Below is the summary of your application. You can review each section and make edits as necessary. You must complete all required items before you can submit your application. <span class="bold" >New questions and sections will appear as you complete your application.</span>';
        this.editModeInstructions.devTeamText = 'A development entity is any entity that is a part of the MIH Development construction project. Please identify the entities that are a part of your development team. You can add as many entities as you wish to your application. <span class= "bold" >Your development team must include at least one Applicant, Owner, and Attorney.</span>'; 
        this.editModeInstructions.siteTeamText = 'In addition to the development team members, you are also required to add entities for Sites. A site entity is any entity that is a part of the MIH Site construction project. <span class="bold">Your site team must include at least one Applicant, Owner, and Architect before initial submission.</span> You can add as many entities as you wish to your site team.';
        this.editModeInstructions.associationText = 'Please identify the building(s) that will contain the MIH units to satisfy the MIH requirement for the buildings listed below. All buildings listed below must have at least one association.';        
    }


    changeToEditMode() {
        this.entityService.changeToEditMode(this.projectId)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        if (successResp.StatusMessage != null && successResp.StatusMessage.indexOf('because it has been either withdrawn') !== -1) {
                            this.showErrorAlert(successResp.StatusMessage);
                        }
                        else {
                            this.showError(AppConfig.config.customErrorMsg);
                        } 
                    }
                    else {

                        this.isAppEditable = true;
                        this.disclaimerChecked = false;
                        this.activeTab = 'Application';
                        this.updateSessionEditMode('Edit'); 
                    }
                },
                errorResp => this.showError(AppConfig.config.customErrorMsg));
    }


    updateSessionEditMode(mode) {
        let rawIdStorage = this.sharedService.getData('id');
        if (rawIdStorage) {
            let jsonIdStorage = JSON.parse(rawIdStorage);
            if (jsonIdStorage) {
                jsonIdStorage.appMode = mode;
                this.sharedService.setData('id', JSON.stringify(jsonIdStorage));
            }
        }
    }

    updateSessionAppStatus(status) {
        let rawIdStorage = this.sharedService.getData('id');
        if (rawIdStorage) {
            let jsonIdStorage = JSON.parse(rawIdStorage);
            if (jsonIdStorage) {
                jsonIdStorage.appStatus = status;
                this.sharedService.setData('id', JSON.stringify(jsonIdStorage));
            }
        }
    }

    isPageExpand() {
        let pageExpand: boolean = false;

        pageExpand = !this.appInfoColl || !this.devTeamColl;
        if (this.buildings && this.buildings.length > 0) {
            pageExpand = pageExpand || this.buildings.filter(x => !x.SiteStyleId).length > 0;
            this.buildings.forEach(x => {
                if (x.BuildingDevTeam && x.BuildingDevTeam.length > 0) {
                    pageExpand = pageExpand || !x.siteTeamStyleId;
                }
            });
        }  

        return pageExpand;
    }

    collapseOrExpand() {
        let collapseFlag: boolean = false;
        collapseFlag = this.isPageExpand();

        this.appInfoColl = collapseFlag;
        this.devTeamColl = collapseFlag;       
        if (this.buildings) {
            this.buildings.forEach(x => {
                x.SiteStyleId = collapseFlag;
                x.siteTeamStyleId = collapseFlag;
            });
        }
    }

    /** Documents */

    updateFileUploadSortColumn(columnName: string) {
        this.fileUploadSortColumn = columnName;
    }

    updateFileUploadSortDirection(direction: string) {
        this.fileUploadSortDirection = direction;
    }
        
    getUploadDocsByProjectId(projectId) {
        this.filesService.getUploadDocsByProjectId(projectId)
            .subscribe(
                successResp => {
                    if (!successResp.Success) {
                        this.showError(successResp.StatusMessage);
                    }
                    else {
                        this.documents = successResp.Result;
                    }
                },
                error => {
                    if (error.status == 401)
                        this.router.navigateByUrl('/login?session=0');

                    this.showError(error.ExceptionMessage)
                });
    }
}
